export class SuperFundModel {
    providerId: number = 0;
    usi: string = '';
    nameOfSuperFund: string = '';
    productName: string = '';
    abn: string = '';
    memberNumber: string = '';
    amountToTransfer: number = 0;
    wholeAmount: number = 1;
}
